import { LitElement, html } from 'lit';
import { CrepeBuilder } from '@milkdown/crepe/builder';
import { blockEdit } from '@milkdown/crepe/feature/block-edit';
import { toolbar } from '@milkdown/crepe/feature/toolbar';
import { listItem } from '@milkdown/crepe/feature/list-item';
import { placeholder } from '@milkdown/crepe/feature/placeholder';
import { markViewCtx } from '@milkdown/kit/core';
import { replaceAll, $prose } from '@milkdown/kit/utils';
import { Plugin } from '@milkdown/kit/prose/state';
import { Fragment, Slice } from '@milkdown/kit/prose/model';
import { EventManager } from '../../utilities/events';
//parent component should import the markdown styles, as this component is light DOM, styles won't be applied if we import it here
export class AllInMarkdownEditor extends LitElement {
    static properties = {
        label: { type: String },
        value: { type: String },
        name: { type: String },
        readonly: { type: Boolean },
        required: { type: Boolean },
        altlabel: { type: String },
        errormessage: { type: String },
    };
    constructor() {
        super();
        this._onEditorKeydown = this._onEditorKeydown.bind(this);
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
    }
    createRenderRoot() {
        return this;
    }
    async firstUpdated() {
        this._crepe = new CrepeBuilder({
            root: this.renderRoot.querySelector('.markdown_editor'),
            defaultValue: this.value,
        });
        if (this.readonly) {
            this._crepe.setReadonly(true);
        }
        else {
            this._crepe.addFeature(blockEdit, {
                advancedGroup: null,
                textGroup: {
                    h1: null,
                    quote: null,
                    divider: null,
                },
                listGroup: {
                    taskList: null,
                }
            });
            this._crepe.addFeature(toolbar);
            this._crepe.addFeature(listItem);
            //this._crepe.addFeature(placeholder);
        }
        this._crepe.editor.config((ctx) => {
            ctx.update(markViewCtx, (prev) => [
                ...prev,
                ['link', (mark) => {
                        const a = document.createElement('span');
                        if (mark.attrs.title)
                            a.title = mark.attrs.title;
                        a.dataset.href = mark.attrs.href;
                        return { dom: a, contentDOM: a };
                    }],
                /*  ['link', (mark) => {
                     const a = document.createElement('a');
                     if (mark.attrs.title) a.title = mark.attrs.title;
                     a.href = mark.attrs.href;
                     a.target = '_blank';
                     a.rel = 'noopener noreferrer';
                     return { dom: a, contentDOM: a };
                 }], */
            ]);
        });
        await this._crepe.create();
        this.initiated = true;
        this._crepe.on((listener) => {
            listener.markdownUpdated((markdown) => {
                this.value = this._sanitizeMarkdown(this._crepe.getMarkdown());
                this.eventManager.emit(`blur`, { value: this.value });
            });
        });
        this._editorDom = this.renderRoot.querySelector('.markdown_editor .ProseMirror');
        if (this._editorDom) {
            this._editorDom.addEventListener('keydown', this._onEditorKeydown);
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('value') && this._crepe && this.initiated) {
            const markdown = this._sanitizeMarkdown(this._crepe.getMarkdown());
            if (this.value !== markdown) {
                this._crepe.editor.action(replaceAll(this.value ?? ''));
            }
        }
    }
    _onEditorKeydown(e) {
        if (e.key === 'Tab' || e.key === 'Escape') {
            e.preventDefault();
            this._editorDom.blur();
        }
    }
    _sanitizeMarkdown(markdown) {
        // Remove angle brackets around raw URLs and email addresses
        return markdown
            .replace(/<(https?:\/\/[^>]+)>/g, '$1')
            .replace(/<\/?a\b[^>]*>/gi, '')
            .replace(/<([^@\s>]+@[^@\s>]+\.[^@\s>]+)>/g, '$1');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._editorDom) {
            this._editorDom.removeEventListener('keydown', this._onEditorKeydown);
            this._editorDom = null;
        }
        if (this._crepe) {
            this._crepe.destroy();
        }
    }
    render() {
        if (this.readonly) {
            return html `\n             <div class="markdown_editor readonly"></div>\n            `;
        }
        return html `\n            ${this.required ? html `\n                <input type="hidden" name="${this.name}" value="${this.value}" aria-required="${this.required}" data-error_message="${this.dataset.error_message}" data-alt_label="${this.altlabel}" >\n            ` : html `\n                <input type="hidden" name="${this.name}" value="${this.value}" data-error_message="${this.dataset.error_message}" data-alt_label="${this.altlabel}" >\n            `}\n            <div style="margin-bottom: 0.5rem; text-align:right;">\n                <allin-tooltip\n                    inline="true"\n                    modalLeft\n                    buttonText="Help fformatio"\n                    .tooltip=${`I gael testun trwm, pwyswch Ctrl + b ar eich bysellfwrdd (Cmd + b ar Mac).\nI gael testun italig, pwyswch Ctrl + i ar eich bysellfwrdd (Cmd + i ar Mac).\nTeipiwch "/" ar baragraff newydd i ddewis o wahanol lefelau pennawd a phwyntiau bwled.`}\n                ></allin-tooltip>\n            </div>\n            <div class="markdown_editor"></div>\n        `;
    }
}
